import { useLazyQuery, useQuery } from "@apollo/client"
import moment from "moment"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Box, Flex, Heading, Text } from "rebass/styled-components"
import styled from "styled-components"
import PleaseWait from "../components/PleaseWait"
import { InputNoForm } from "../components/TextInput"
import { GET_LAST_SEENS, GET_UPCOMINGS, SEARCH_PATIENT_BY_NAME } from "../graphql/queries"
import { IGetUpcominsInput, IGetUpcominsOutput, ILastSeenInput, ILastSeenOutput } from "../graphql/types/queries/appointment"
import { ISearchProviderPatientsByNameInput, ISearchProviderPatientsByNameOutput } from "../graphql/types/queries/patient"
import { Constants } from "../utils/Constants"
import { LastSeen } from "./dashboard/LastSeen"
import { Upcomings } from "./dashboard/Upcomings"
import { SearchResults } from "./patients/SearchResults"
import HealthCoachingUsers from "./patients/HealthCoachingUsers"
import SwitchSelector from "react-switch-selector"
import Select, { ActionMeta, components } from "react-select";
import { RbCircledChecked, RbCircledUnchecked } from "../components/RadioButton"
import { ReactSelectStyles } from "../styles/ReactSelectStyles"

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: #C9C9C9;
  margin-top: 12px;
  margin-bottom: 12px;
`

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 100px;
  @media screen and (min-width: 68.8125em) {
  padding: ${() => `${Constants.OUTLETS_PADDING}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
  padding-bottom: 0;
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  /* padding-bottom: 0; */
  }
`

const SelectorLarge = styled(Flex)`
  display: none;
  @media screen and (min-width: 1740px) {
    display: initial;
  }
`

const SelectorSmall = styled(Flex)`
  display: none;
  @media screen and (max-width: 1739px) {
    display: initial;
  }
`
const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};
const options = [
  {
    label: 'Last Seen',
    value: 'LastSeen',
    selectedBackgroundColor: "#6c89b7",
    selectedFontColor:'white'
  },
  {
    label: "Health Coaching Patients",
    value: "HealthCoachingPatients",
    selectedBackgroundColor: "#6c89b7",
    selectedFontColor:'white'
  },
];

const optionsMobile = [
  {
    label: 'Last Seen',
    value: 'LastSeen',
    selectedBackgroundColor: "#BCFFEB",
  },
  {
    label: "Health Coaching Patients",
    value: "HealthCoachingPatients",
    selectedBackgroundColor: "#BCFFEB"
  },
];

const Patients = () => {
  // return <Flex />
  const { state } = useLocation()
  const [selectedView, setselectedView] = useState<'HealthCoachingPatients' | 'LastSeen'>('LastSeen');
  const { data, loading, error, refetch } = useQuery<ILastSeenOutput, ILastSeenInput>(GET_LAST_SEENS)
  const { data: dataUpcoming, loading: loadingUpcoming, error: errorUpcoming, refetch: refetchUpcoming } = useQuery<IGetUpcominsOutput, IGetUpcominsInput>(GET_UPCOMINGS)
  const [searchPatients, { data: dataSearch, loading: loadingSearch, error: errorSearch }] = useLazyQuery<ISearchProviderPatientsByNameOutput, ISearchProviderPatientsByNameInput>(SEARCH_PATIENT_BY_NAME)
  const navigate = useNavigate()
  const [search, setSearch] = useState<string>((state as any)?.search || '')
  const [prefix, setPrefix] = useState<'' | null | 'name' | 'athenaId'>(null)
  const [hasTriggeredSearch, setHasTriggeredSearch] = useState<boolean | null>(false)

  useEffect(() => {
    if (!search) {
      setPrefix(null)
      return
    }

    let value: string | number

    try {
      value = parseInt(search)
    } catch (error) {
      value = search
    }

    if (!value) {
      value = search
    }

    if (isNaN(value as any)) {
      setPrefix('name')
    } else {
      setPrefix('athenaId')
    }
  }, [search])

  useEffect(() => {
    if (state && (state as any).search) {
      setSearch((state as any).search)
      setTimeout(() => onSearch(), 0)
    }
  }, [])

  const enterSearch = (text: string) => {
    setSearch(text)
    setHasTriggeredSearch(false)
  }

  const onSearch = () => {
    if (!search) return
    if (prefix === 'athenaId') {
      navigate(`/patient/${search.trim()}`)
      return
    }
    setHasTriggeredSearch(true)
    searchPatients({
      variables: {
        search
      }
    })
  }

  return (
    <Container flexDirection={'column'} style={{ height: '100%' }} overflow={'hidden'}>
      <Heading mb={3}>Patients</Heading>
      <Flex flexDirection={'column'}>
        <Text style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)' }}>Search patients by name or patient ID</Text>
        <Flex mt={3} flexDirection={'row'} style={{ background: 'white', borderRadius: '12px', padding: '0 12px', height: '50px', overflow: "hidden" }} alignItems='center'
          onClick={() => {
          }}>
          {!!prefix ? (
            <Box style={{ background: prefix === 'name' ? '#aeeedb' : '#FFE6E2', height: '100%', margin: '0 0 0 -12px', display: 'flex', alignItems: 'center', padding: '0 8px 0 12px', marginRight: '12px' }}>
              <Text color={prefix === 'name' ? '#46937c' : '#F6A293'}>{prefix === 'name' ? 'name:' : 'Athena ID:'}</Text>
            </Box>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" />
            </svg>
          )}
          <InputNoForm type="search"
            onReturn={onSearch}
            autoFocus
            onChange={(e: any) => {
              enterSearch(e.target.value)
            }}
            style={{ backgroundColor: 'white', border: '0px', flex: 1, paddingTop: '12px', paddingBottom: '12px' }}
            value={search}
            containerStyle={{ flex: 1 }}
            placeholder='last name or patient id' />

        </Flex>
      </Flex>


      <Flex flexDirection={'column'} mt={2} paddingBottom={['24px', 0]} justifyContent="flex-start" overflow={'hidden'}>
        <Divider />
        <Flex height={['30px', '30px', '30px']} mb='12px'>

          <SelectorLarge flex={1} minWidth={'min(640px, 100%)'} maxWidth={'min(640px, 100%)'}>
            <SwitchSelector
              onChange={(val) => {
                setselectedView(val as 'LastSeen'|'HealthCoachingPatients')
              }}
              forcedSelectedIndex={['LastSeen', 'HealthCoachingPatients'].indexOf(selectedView)}
              options={options}
              backgroundColor={"transparent"}
              fontColor={"#344F7A"}
              selectedFontColor={"#344F7A"}
              selectedBackgroundColor={"#BCFFEB"}
            />
          </SelectorLarge>
          <SelectorSmall flex={1} maxWidth={'200px'}>
            <Select
              isSearchable={false}
              styles={ReactSelectStyles.initialStyles}
              options={optionsMobile}
              value={optionsMobile[optionsMobile.findIndex(x => x.value === selectedView)]}
              onChange={(val) => {
                setselectedView(val && val.value ? val.value as any : 'LastSeen')
              }}
              components={{ Option }} />
          </SelectorSmall>
        </Flex>
        <Flex flexDirection={['column', 'row', 'row']} mt={2} flex={1} mb={['150px', 'initial', 'initial']} overflow={'hidden'}>
          {!hasTriggeredSearch ? (
            <>
              {!search ? (
                <>
                  {selectedView === 'HealthCoachingPatients' ? (
                    <HealthCoachingUsers />
                  ) : (
                    <LastSeen data={data} loading={loading} error={error} refetch={refetch} />)}
                  <Upcomings data={dataUpcoming} loading={loadingUpcoming} error={errorUpcoming} refetch={refetchUpcoming} selectedDate={moment().format('MM/DD/YYYY')} />
                </>
              ) : (
                <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
                  <svg width="96" height="96" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" />
                  </svg>
                  <Text fontSize={'38px'} fontWeight={600} mt={'28px'}>
                    {prefix === 'name' ? `Patient named ${search}` : `Patient ID ${search}`}
                  </Text>
                  <Text style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)', fontStyle: 'italic' }}>Press enter to search</Text>
                </Flex>
              )}
            </>
          ) : (
            <>
              {!!loadingSearch ? (
                <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
                  <PleaseWait
                    text={`Searching for ${search}`} />
                </Flex>
              ) : (
                <SearchResults data={dataSearch} error={errorSearch} searched={search!} />
              )}
            </>
          )}

        </Flex>
      </Flex >
    </Container>
  )
}

export default (Patients)